// Gestores (7-oct-2026): la pestaña «Gestión» de Analítica y los filtros de gestionados /
// propios / propietario de las pestañas Desempeño y Canales.
export const gestionAnalytics = {
  tab: "Gestión",
  tabRestricted: "Mi liquidación",
  restrictedTitle: "Mi liquidación",

  pageFilters: {
    ownership: "Alojamientos",
    ownershipAll: "Gestionados y propios",
    ownershipManaged: "Solo gestionados",
    ownershipOwn: "Solo propios",
    owner: "Propietario",
    allOwners: "Todos los propietarios",
  },

  views: {
    business: "Mi negocio",
    owners: "Propietarios",
    expenses: "Egresos",
  },

  filters: {
    listings: "Alojamientos",
    allListings: "Todos",
    someListings: "{count} alojamientos",
    owner: "Propietario",
    allOwners: "Todos",
    attribution: "Contar reservas por",
    checkout: "Fecha de salida",
    checkin: "Fecha de entrada",
    nights: "Noches del periodo",
    attributionHelp: "Por salida es como se liquida a los propietarios: la estancia ya terminó.",
    attributionHelpLabel: "Qué significa «Contar reservas por»",
    currency: "Moneda",
  },

  warnings: {
    otaEstimated:
      "{count} reserva con la comisión de la OTA estimada por porcentaje: el canal no informó la real. | {count} reservas con la comisión de la OTA estimada por porcentaje: el canal no informó la real.",
    noBreakdown:
      "{count} reserva sin desglose: todo su importe se ha tomado como alojamiento. | {count} reservas sin desglose: todo su importe se ha tomado como alojamiento.",
    outdatedBreakdown:
      "{count} reserva se editó o amplió después de importarse: se ha tomado su importe actual. | {count} reservas se editaron o ampliaron después de importarse: se ha tomado su importe actual.",
    otherCurrencies: "Hay alojamientos en otra moneda ({currencies}). Cámbiala arriba para verlos.",
    noOwner:
      "{count} alojamiento gestionado no tiene propietario asignado. | {count} alojamientos gestionados no tienen propietario asignado.",
    assignOwners: "Asignar propietarios",
  },

  states: {
    loadError: "No se ha podido cargar la información de gestión.",
    forbidden: "No tienes permiso para ver esta información.",
    periodTooLong: "Elige un periodo de dos años como mucho.",
    retry: "Reintentar",
    noMovements: "Sin movimientos en este periodo",
  },

  empty: {
    title: "¿Gestionas alojamientos de otros propietarios?",
    text: "Indica en cada alojamiento que lo gestionas para un propietario y en qué condiciones: tu comisión, quién cobra las reservas y cómo se reparten las limpiezas. Aquí verás lo que ganas tú y lo que corresponde a cada propietario.",
    point1: "Tus comisiones, limpiezas y egresos, con tu beneficio real",
    point2: "Lo que toca transferir o cobrar a cada propietario",
    point3: "La liquidación de cada propietario en PDF o Excel",
    cta: "Configurar mis alojamientos",
  },

  period: {
    subtitle: "{period} · {attribution} · {granularity}",
    byCheckout: "reservas por fecha de salida",
    byCheckin: "reservas por fecha de entrada",
    byNights: "noches del periodo",
    day: "por día",
    week: "por semana",
    month: "por mes",
  },

  counts: {
    reservations: "{count} reserva | {count} reservas",
    nights: "{count} noche | {count} noches",
    units: "{count} alojamiento | {count} alojamientos",
    ownUnits: "{count} alojamiento propio | {count} alojamientos propios",
    owners: "{count} propietario | {count} propietarios",
  },

  business: {
    kpi: {
      managedGross: "Facturación gestionada",
      commissions: "Tus comisiones",
      cleaning: "Limpiezas",
      ownRevenue: "Ingresos de pisos propios",
      expenses: "Egresos",
      profit: "Beneficio",
    },
    vatLine: "+ IVA {amount}",
    ofTotal: "del total facturado",
    overManaged: "sobre lo gestionado",
    ofIncome: "de tus ingresos",
    margin: "de margen",
    chartTitle: "Ingresos, egresos y beneficio",
    chartA11y: "Gráfica de los ingresos, los egresos y el beneficio del periodo",
    legend: {
      commissions: "Comisiones",
      cleaning: "Limpiezas",
      own: "Pisos propios",
      expenses: "Egresos",
      profit: "Beneficio",
    },
    byCategory: "Egresos por categoría",
    category: "Categoría",
    amount: "Importe",
    noExpenses: "Sin egresos en este periodo",
    seeExpenses: "Ver egresos",
  },

  owners: {
    kpi: {
      gross: "Ingresos de reservas",
      ota: "Comisiones OTA",
      cleaning: "Limpiezas",
      commission: "Tu comisión + IVA",
      commissionRestricted: "Comisión del gestor + IVA",
      charged: "Gastos repercutidos",
      net: "Neto para propietarios",
      netRestricted: "Tu neto",
    },
    ofGross: "de los ingresos",
    collectedByYou: "lo cobras tú",
    collectedByManager: "lo cobra tu gestor",
    commissionLine: "{commission} + IVA {vat}",
    otaLine: "{commission} + IVA {vat}",
    otaTitle: "Comisión de las OTAs {commission} + IVA {vat}",
    commissionTitle: "Comisión {commission} + IVA {vat}",
    toTransfer: "A transferir a propietarios",
    toCollect: "A cobrar a propietarios",
    toTransferRestricted: "Te transfiere tu gestor",
    toCollectRestricted: "A pagar a tu gestor",
    chartTitle: "Reparto de lo ingresado",
    chartA11y: "Gráfica del reparto de los ingresos de las reservas gestionadas",
    legend: {
      net: "Neto propietarios",
      netRestricted: "Tu neto",
      commissions: "Tus comisiones",
      commissionsRestricted: "Comisión del gestor",
      ota: "Comisiones OTA",
      cleaning: "Limpiezas",
      other: "Tasas, fianzas, IVA y gastos",
    },
    grossFooter: "Ingresos: {amount}",
    tableTitle: "Liquidación por propietario",
    tableTitleRestricted: "Detalle de tu liquidación",
    downloadAll: "Descargar todo (PDF)",
    download: "Descargar (PDF)",
    downloading: "Descargando…",
    pdf: "PDF",
    excel: "Excel",
    exportError: "No se ha podido descargar la liquidación.",
    cols: {
      owner: "Propietario",
      reservations: "Reservas",
      gross: "Ingresos",
      ota: "OTA",
      cleaning: "Limpieza",
      commission: "Comisión + IVA",
      charged: "Gastos",
      net: "Neto",
      balance: "Saldo",
      actions: "Descargas",
    },
    noOwner: "Sin propietario asignado",
    transfer: "Transferir {amount}",
    collect: "Cobrar {amount}",
    receive: "A recibir {amount}",
    pay: "A pagar {amount}",
    collectionManager: "Cobra el gestor",
    collectionOwner: "Cobra el propietario",
    total: "Total",
    expand: "Ver el detalle de {name}",
    collapse: "Ocultar el detalle de {name}",
    iban: "IBAN {iban}",
    showReservations: "Ver reservas ({count})",
    hideReservations: "Ocultar reservas",
    noData: "No hay reservas gestionadas en este periodo.",
    reservations: {
      checkIn: "Entrada",
      checkOut: "Salida",
      guest: "Huésped",
      listing: "Alojamiento",
      channel: "Canal",
      gross: "Ingresos",
      ota: "OTA",
      cleaning: "Limpieza",
      commission: "Comisión",
      vat: "IVA",
      net: "Neto",
      direct: "Directa",
      estimated: "est.",
      estimatedHelp: "Estimada por porcentaje: el canal no informó la comisión real.",
      noBreakdown: "sin desglose",
      noBreakdownHelp: "La reserva no trae desglose: todo su importe se ha tomado como alojamiento.",
      complete: "Completar",
      completed: "Completado",
      completeHelp: "Completa la limpieza, la comisión real de la OTA o la limpieza de esta reserva",
      manual: "a mano",
      manualHelp: "Comisión de la OTA puesta a mano en esta reserva.",
      loading: "Cargando reservas…",
      loadError: "No se han podido cargar las reservas.",
      empty: "No hay reservas en este periodo.",
    },
    charged: {
      title: "Gastos repercutidos",
      date: "Fecha",
      concept: "Concepto",
      listing: "Alojamiento",
      amount: "Importe",
      general: "General",
    },
  },

  a11y: {
    views: "Secciones de gestión",
  },
  // Liquidación por propietario: la cuenta y las columnas del PDF.
  liq: {
    precio: "Precio",
    comision: "Comisión OTA",
    tasas: "Tasas",
    limpieza: "Limpieza",
    honorarios: "Honorarios",
    honorariosIva: "Honorarios + IVA",
    neto: "Neto propietario",
    transfieres: "Le transfieres",
    tePaga: "Te paga",
    recibes: "Recibes",
    pagas: "Pagas",
    netoPropietarios: "Neto para propietarios",
    formula: "Ingreso = Precio − Comisión · Total = Ingreso − Tasas − Limpieza · Neto = Total − Honorarios − IVA. Igual que en el PDF y el Excel.",
    cols: {
      origen: "Origen",
      nombre: "Nombre",
      entrada: "Entrada",
      salida: "Salida",
      precio: "Precio",
      noches: "Noches",
      comision: "Comisión",
      ingreso: "Ingreso",
      tasas: "Tasas",
      limpieza: "Limpieza",
      total: "Total",
      honorarios: "Honorarios",
      iva: "IVA",
      neto: "Neto",
    },
  },
};
